import { mapState } from 'vuex';
import f from "@/application/shared/functions.js";

export default {
    name: 'pinfallback',
    props: {
    },

    data : function(){

        return {
            loading : false,
            num1 : 0,
            num2 : 0,
            result : ''
        }

    },

    created (){
        this.num1 = f.rand(5, 30)
        this.num2 = f.rand(5, 30)

        setTimeout(() => {
            if(this.$refs['input']) this.$refs['input'].focus()
        }, 300)
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {
        apply : function(){

            if (this.num1 + this.num2 == this.result){
                this.$emit('success')
            }
            
            this.$emit('close')
        },

        cancel : function(){
            this.$emit('close')
        }
    },
}